import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { gridMediumMaxWidth } from '@atlaskit/editor-shared-styles';
var columnLayoutSharedStyle = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '[data-layout-section]': _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
      flex: 1,
      minWidth: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > .unsupportedBlockView-content-wrap': {
      minWidth: 'initial'
    }
  }, "@media screen and (max-width: ".concat(gridMediumMaxWidth, "px)"), {
    flexDirection: 'column'
  })
});
var columnLayoutResponsiveSharedStyle = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-layout-section]': {
    display: 'flex',
    flexDirection: 'row',
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > *': {
      flex: 1,
      minWidth: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > .unsupportedBlockView-content-wrap': {
      minWidth: 'initial'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.layout-section-container': {
    containerType: 'inline-size',
    containerName: 'layout-area'
  }
});
var LAYOUT_BREAKPOINT_RENDERER = 629;

/* jest warning: JSDOM version (22) doesn't support the new @container CSS rule */
var columnLayoutResponsiveRendererStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.layout-section-container': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': _defineProperty({
      gap: "var(--ds-space-600, 48px)"
    }, "@container layout-area (max-width:".concat(LAYOUT_BREAKPOINT_RENDERER, "px)"), {
      flexDirection: 'column',
      gap: "var(--ds-space-400, 32px)"
    })
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export { columnLayoutSharedStyle, columnLayoutResponsiveSharedStyle, columnLayoutResponsiveRendererStyles };